import { defineComponent as _defineComponent } from 'vue'
import type { FilterName } from '@/stores/useFilterStoreTypes';

import BasicButton from '@/ui-components/BasicButton.vue';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useRouter } from 'vue-router/composables';
import { isNavigationFailure, NavigationFailureType } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetButton',
  props: {
    filterNames: { default: () => [] },
    updateRouteState: { type: Boolean, default: true },
    keepProvidersState: { type: Boolean, default: false },
    keepContentTypeState: { type: Boolean, default: false }
  },
  emits: ['resetClicked'],
  setup(__props: any, { emit: emits }) {

const props = __props as { filterNames: FilterName[], updateRouteState: boolean, keepProvidersState: boolean, keepContentTypeState: boolean };





const router = useRouter();

const filterStore = useFilterStore();

async function clickHandler() {
	// Note: Reset providers selection for SEO users, since we still use old Filters bar for SEO users
	emits('resetClicked');

	let newRoute;

	if (props.filterNames.length > 0) {
		newRoute = filterStore.resetFilters({
			filterNames: props.filterNames,
			updateRouteState: props.updateRouteState,
		});
	} else {
		newRoute = await filterStore.reset({
			keepProvidersState: props.keepProvidersState,
			keepContentTypeState: props.keepContentTypeState,
		});
	}

	if (newRoute) {
		router.push(newRoute).catch((error: any) => {
			if (
				!isNavigationFailure(error, NavigationFailureType.duplicated) &&
				!isNavigationFailure(error, NavigationFailureType.cancelled)
				// a reset of the filters sometimes triggers a navigation to the same page
			) {
				throw error;
			}
		});
	}
}

return { __sfc: true,props, emits, router, filterStore, clickHandler, BasicButton, faTimes }
}

})